import { useCallback, useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { pick, prop } from 'ramda';

import { EVENTS_DATA } from 'js/app/hooks/analiticsSubscribe/constants';
import { useUserSelector } from 'js/store/hooks';

import { useGtmEvent } from './useGtmEvent';

const useSubscribeAnalytics = () => {
    const gtmEvent = useGtmEvent();

    return useCallback((eventName, analyticType, additionalData = []) => {
        const fnListener = (data) => gtmEvent(analyticType, pick(additionalData, data));

        dispatcher.listen(eventName, fnListener);

        return fnListener;
    }, [gtmEvent]);
};

const useAnalytics = (events = []) => {
    const subscribeAnalytics = useSubscribeAnalytics();

    useEffect(() => {
        const fnListenerList = [];
        events.forEach(eventData => {
            const fnListener = subscribeAnalytics(...eventData);

            fnListenerList.push({
                eventName: eventData[0],
                fnListener
            });
        });

        return () => {
            fnListenerList.forEach(({ eventName, fnListener }) => {
                dispatcher.removeListener(eventName, fnListener);
            });
        };

    }, [events, subscribeAnalytics]);
};

const useUpdateBalance = () => {
    const gtmEvent = useGtmEvent();
    const updatedBalances = useUserSelector(prop('updatedBalances'));

    return useCallback(() => {
        if (!updatedBalances?.length) {
            return;
        }

        gtmEvent('user_balance_updated', { updatedBalances });
    }, [gtmEvent, updatedBalances]);
};

export const useAnalyticsSubscribe = () => {
    useAnalytics(EVENTS_DATA);

    const updateBalance = useUpdateBalance();

    useEffect(() => {
        dispatcher.listen('user:balanceUpdated', updateBalance);

        return () => {
            dispatcher.removeListener('user:balanceUpdated', updateBalance);
        };
    }, [updateBalance]);
};
